import type { FC } from "react";

import TelemetryHoc from "@Components/telemetry-hoc/telemetry-hoc";
import * as stylex from "@stylexjs/stylex";

import { ComposableSpacing, colors } from "../../styles/tokens.stylex";
import type { ILogoTile } from "../common/LogoTile";
import LogoTile from "../common/LogoTile";

const styles = stylex.create({
    wrapper: {
        position: "relative",
        padding: "1px",
        paddingTop: "10px",
    },
    counter: {
        position: "absolute",
        right: "-10px",
        top: "0",
        width: "40px",
        textAlign: "center",
        color: "white",
        zIndex: 1,
        backgroundColor: colors.grayLight,
        borderRadius: ComposableSpacing.s1,
    },
    inactive: {
        opacity: 0.5,
    },
});

export interface ILogoTileWithCounter extends ILogoTile {
    discountCount: number;
    isActive?: boolean;
}

export const LogoTileWithCounter: FC<ILogoTileWithCounter> = ({ isActive, discountCount, ...props }) => {
    return (
        <TelemetryHoc
            telemetryCustom={props.telemetryCustom}
            styleX={[styles.wrapper, isActive === false ? styles.inactive : undefined]}
        >
            {discountCount >= 0 && <div {...stylex.props(styles.counter)}>{discountCount}</div>}
            <LogoTile {...props} />
        </TelemetryHoc>
    );
};
